<div class="waiting-payment-info">
    <!-- <span class="message"> {{'REQUEST.ALERT.WAITING_FOR_INFORMATION' | translate}}</span> -->
    <div class="tracking-number">
        <div class="label">{{'REQUEST.TRACKING_NUMBER' | translate}}:</div> 
        <div class="number">{{trackingNumber}}</div><i class="far fa-copy" CopyText text="{{trackingNumber}}"></i>
    </div>
</div>